import settings from "./modules/settings/Settings";
import user from "./modules/user/User";
import theme from "./modules/theme/Theme";
import userAndRoles from "./modules/user/UserRoles";
import notificationSettings from "./modules/settings/NotificationSettings";
import formBuilder from "./modules/customFormBuilder/formBuilder";
import viewAttachDocument from "./modules/viewAttachDocument/viewAttachDocument";
import userCompanyProfile from "./modules/userCompanyProfile/userCompanyProfile";
import uploadFilePath from "./modules/uploadFilePath/uploadFilePath";
import inputMode from "./modules/customFormBuilder/inputMode";
import formdesigner from "./modules/formdesigner/FormDesigner";
import taskformtype from "./modules/taskformtype/taskformtype";
import sharedData from "./modules/SharedData";
import saveFormState from "./modules/saveFormWizard/store";
import clientRegistration from "./modules/clientRegistration/store";
export default {
  modules: {
    theme,
    settings,
    user,
    userAndRoles,
    notificationSettings,
    formBuilder,
    viewAttachDocument,
    userCompanyProfile,
    uploadFilePath,
    inputMode,
    formdesigner,
    taskformtype,
    sharedData,
    saveFormState,
    clientRegistration
  },
};
